import React from "react";
import { FiHeadphones, FiPhone, FiMail } from "react-icons/fi";

const ContactStrip = ({ customEmail = "services@mygoldenhomes.com" }) => {
  return (
    <div className="mgh-contact-strip">
      <div className="mgh-contact-strip-header">
        <div className="mgh-contact-strip-icon">
          <FiHeadphones />
        </div>
        <div>
          <h4>Need to get in touch?</h4>
          <p>We're here to help. Reach out to us for any questions related to our services, partnerships or media inquiries.</p>
        </div>
      </div>

      <div className="mgh-contact-strip-col">
        <span className="sub">Toll Free (9 AM - 8 PM IST)</span>
        <strong>
          <FiPhone size={13} />
          <a href="tel:+919063483711">+91 90634 83711</a>
        </strong>
      </div>

      <div className="mgh-contact-strip-col">
        <span className="sub">International Support</span>
        <div style={{ fontSize: "12px", color: "#334155", lineHeight: "1.5" }}>
          <div>UAE: <a href="tel:+9190634837119" style={{ color: "#0284c7", fontWeight: "600", textDecoration: "none" }}>+91 906348 37119</a></div>
          <div>USA/UK: <a href="tel:18004199099" style={{ color: "#0284c7", fontWeight: "600", textDecoration: "none" }}>1800-41-99099</a></div>
        </div>
      </div>

      <div className="mgh-contact-strip-col">
        <span className="sub">Email Assistance</span>
        <strong>
          <FiMail size={13} />
          <a href={`mailto:${customEmail}`}>{customEmail}</a>
        </strong>
      </div>
    </div>
  );
};

export default ContactStrip;
